import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

// Two fully independent sessions: the customer (public) site and the staff/admin console
// each keep their own token and never affect one another.
export const CUSTOMER_TOKEN = "qr_customer_token";
export const STAFF_TOKEN = "qr_staff_token";
const STAFF_PREFIXES = ["/admin", "/station", "/teller", "/cashier", "/management", "/control", "/operations"];
// Pages used by BOTH staff and customers: prefer the staff session when a staff token exists
// (e.g. a teller scanning a QR at /verify, or a station master on the arrivals board), else customer.
// NOTE: /ticket (the customer booking confirmation, incl. the Hubtel payment return) is intentionally
// NOT shared - it must always render on the customer site even if a staff token exists in the browser.
const SHARED_PREFIXES = ["/verify", "/arrivals", "/track"];
export const areaForPath = (p = "") => {
  if (STAFF_PREFIXES.some((x) => p === x || p.startsWith(x + "/"))) return "staff";
  if (SHARED_PREFIXES.some((x) => p === x || p.startsWith(x + "/"))) {
    try { if (localStorage.getItem(STAFF_TOKEN)) return "staff"; } catch { /* ignore */ }
    return "customer";
  }
  return "customer";
};
export const tokenKey = (area) => (area === "staff" ? STAFF_TOKEN : CUSTOMER_TOKEN);

api.interceptors.request.use((c) => {
  // `area` can be forced per-request (e.g. refreshing both sessions on load); otherwise it is
  // inferred from the page the user is on so the right session's token is sent.
  const area = c.area || areaForPath(typeof window !== "undefined" ? window.location.pathname : "");
  const t = localStorage.getItem(tokenKey(area));
  if (t) c.headers.Authorization = `Bearer ${t}`;
  c.headers["X-Client"] = c.client || (area === "staff" ? "teller_web" : "public_web");
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}
